// Sentry init sidecar — imported FIRST in src/index.js so it runs before any app code.
// The SDK is disabled entirely when REACT_APP_SENTRY_DSN is unset, so this is a safe
// no-op in dev/preview/prod until a DSN is provided at build time (CRA inlines REACT_APP_*).
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_VERSION,
    integrations: [
      // Router-aware browser tracing for React Router v7 (declarative <Routes>).
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      // Session Replay around errors (text masked, media blocked — privacy-safe defaults).
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    // Tracing — keep modest in production.
    tracesSampleRate: 0.2,
    // Only attach trace headers to our own backend to avoid third-party CORS issues.
    tracePropagationTargets: [process.env.REACT_APP_BACKEND_URL].filter(Boolean),
    // Session Replay sampling: rare for normal sessions, always when an error occurs.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export default Sentry;
